import CpxResearch  from "~/pages/Surveys/Providers/CpxResearch";
import Theoremreach from "~/pages/Surveys/Providers/TheoremReach";
import BitLabs      from "~/pages/Surveys/Providers/BitLabs";
//import Wannads    from "~/pages/Surveys/Providers/Wannads";
//import Monlix     from "~/pages/Surveys/Providers/Monlix";
import InBrainAi    from "~/pages/Surveys/Providers/InBrainAi";
import Pollfish     from "~/pages/Surveys/Providers/Pollfish";
import OfferDaddy   from "~/pages/Surveys/Providers/OfferDaddy";
import Yuno         from "~/pages/Surveys/Providers/Yuno";
import RevenueWall  from "~/pages/Surveys/Providers/RevenueWall";

import OfferToro           from "~/pages/Offers/Providers/OfferToro";
import Adgem               from "~/pages/Offers/Providers/Adgem";
import Wannads             from "~/pages/Offers/Providers/Wannads";
import AyetStudios         from "~/pages/Offers/Providers/AyetStudios";
import Admantium           from "~/pages/Offers/Providers/Admantium";
import OfferDaddyOfferWall from "~/pages/Offers/Providers/OfferDaddy";
import Personaly           from "~/pages/Offers/Providers/Personaly";
import Lootably            from "~/pages/Offers/Providers/Lootably";
import AdgateMedia         from "~/pages/Offers/Providers/AdgateMedia";
import Monlix              from "~/pages/Offers/Providers/Monlix";
import Kiwi                from "~/pages/Offers/Providers/Kiwi";
import HangMyAds           from "~/pages/Offers/Providers/HangMyAds";
import TimeWall            from "~/pages/Offers/Providers/TimeWall";
import ClixWall            from "~/pages/Offers/Providers/ClixWall";
import NotikMe             from "~/pages/Offers/Providers/NotikMe";
import MakeMoneyTop        from "~/pages/Offers/Providers/MakeMoneyTop";
import Sumpix              from "~/pages/Offers/Providers/Sumpix";
import MAF                 from "~/pages/Offers/Providers/MAF";
import SushyAds            from "~/pages/Offers/Providers/SushyAds";
import AddBreakMedia       from "~/pages/Offers/Providers/AdBreakMedia";
import Revlum              from "~/pages/Offers/Providers/Revlum";
import ClixSquare          from "~/pages/Offers/Providers/ClixSquare";

import Home           from "~/pages/Home";
import Offers         from "~/pages/Offers/index2";
import Surveys        from "~/pages/Surveys";
import TournamentPage from "~/pages/Tournament";
import GamesPage      from "~/pages/Games";
import TasksPage      from "~/pages/Task";
import LotteryPage    from "~/pages/Lottery";
import Referrals      from "~/pages/Referrals";
import Promo          from "~/pages/Promo";
import Wallet         from "~/pages/Wallet";
import Profile        from "~/pages/Profile";
import CheckIn        from "~/pages/CheckIn";
import Cashouts       from "~/pages/Cashouts";
import Support        from "~/pages/Support";
import BetPage        from "~/pages/Bet";

import Tracking             from "~/pages/Tracking";
import Login                from "~/pages/Authentication/Login";
import ResetPasswordRequest from "~/pages/Authentication/ResetPassword/RequestForm";
import ResetPassword        from "~/pages/Authentication/ResetPassword/ResetForm";

import Register             from "~/pages/Authentication/Register/Register";
import ReferralPage         from "~/pages/Authentication/Register/ReferralPage";
import RegisterConfirmation from "~/pages/Authentication/Register/Confirmation";

import GoogleAuthCallback   from "~/pages/Authentication/Login/ThirdPartyLogin/Google/Callback";
import FacebookAuthCallback from "~/pages/Authentication/Login/ThirdPartyLogin/Facebook/Callback";

import ContestsPage from "../pages/Contest";
import CashbacksPage from "../pages/Cashbacks";




export const routes = [
  { path: '/dashboard/:shareId?'    , Component: Home                            , expandedHeader: true },
  { path: '/offers/:shareId?'       , Component: Offers      , background: '#fff', expandedHeader: true },
  { path: '/surveys'                , Component: Surveys     , background: '#fff', expandedHeader: true },
  { path: '/check-in'               , Component: CheckIn     , background: '#fff' },
  { path: '/referrals'              , Component: Referrals   , background: '#fff' },
//  { path: '/lottery'                , Component: LotteryPage , background: '#fff' },
  { path: '/wallet'                 , Component: Wallet      , background: '#fff' },
  { path: '/games'                  , Component: GamesPage   , background: '#fff' },
  { path: '/profile'                , Component: Profile     , background: '#fff' },
  { path: '/support'                , Component: Support     , background: '#fff' },
  { path: '/tgbonus/:code'          , Component: Promo       , background: '#fff' },
  { path: '/tasks'                  , Component: TasksPage                        },
  { path: '/rewards'                , Component: Cashouts    , background: '#fff' },
  { path: '/tournament'             , Component: TournamentPage                   },
//  { path: '/jackpot'                , Component: BetPage                          },
//  { path: '/contests'               , Component: ContestsPage                     },
//  { path: '/cashbacks'              , Component: CashbacksPage                    },
];

export const authRoutes = [
  { path: '/adv-tracking/:networkId'      , Component: Tracking             } ,
  { path: '/login'                        , Component: Login                } ,
  { path: '/register'                     , Component: Register             } ,
  { path: '/join'                         , Component: ReferralPage         } ,
  { path: '/register-confirmation/:token' , Component: RegisterConfirmation } ,
  { path: '/reset-password-request'       , Component: ResetPasswordRequest } ,
  { path: '/reset-password/:token'        , Component: ResetPassword        } ,
  { path: '/google-oauth2-callback'       , Component: GoogleAuthCallback   } ,
  { path: '/facebook-oauth2-callback'     , Component: FacebookAuthCallback } ,
];

export const iframeRoutes = [
  { path: '/surveys/cpx-research'  , Component: CpxResearch           },
  { path: '/surveys/bitlabs'       , Component: BitLabs               },
  { path: '/surveys/inbrain-ai'    , Component: InBrainAi             },
  { path: '/surveys/pollfish'      , Component: Pollfish              },
  { path: '/surveys/offer-daddy'   , Component: OfferDaddy            },
  { path: '/surveys/yuno'          , Component: Yuno                  },
  { path: '/surveys/theorem-reach' , Component: Theoremreach          },
  { path: '/surveys/revenue-wall'  , Component: RevenueWall           },
// { path: '/surveys/wannads'       , Component: Wannads },
// { path: '/surveys/monlix'        , Component: Monlix },
  { path: '/offers/adgem'          , Component: Adgem                 },
  { path: '/offers/offertoro'      , Component: OfferToro             },
  { path: '/offers/wannads'        , Component: Wannads               },
  { path: '/offers/offer-daddy'    , Component: OfferDaddyOfferWall   },
  { path: '/offers/ayet-studios'   , Component: AyetStudios           },
  { path: '/offers/admantium'      , Component: Admantium             },
  { path: '/offers/personaly'      , Component: Personaly             },
  { path: '/offers/lootably'       , Component: Lootably              },
  { path: '/offers/adgate-media'   , Component: AdgateMedia           },
  { path: '/offers/monlix'         , Component: Monlix                },
  { path: '/offers/kiwi'           , Component: Kiwi                  },
  { path: '/offers/hang-my-ads'    , Component: HangMyAds             },
  { path: '/offers/timewall'       , Component: TimeWall              },
  { path: '/offers/clixwall'       , Component: ClixWall              },
  { path: '/offers/notikme'        , Component: NotikMe               },
  { path: '/offers/makemoneytop'   , Component: MakeMoneyTop          },
  { path: '/offers/maf'            , Component: MAF                   },
  { path: '/offers/sumpix'         , Component: Sumpix                },
  { path: '/offers/sushyads'       , Component: SushyAds              },
  { path: '/offers/addBreakMedia'  , Component: AddBreakMedia         },
  { path: '/offers/revlum'         , Component: Revlum                },
  { path: '/offers/clixsquare'     , Component: ClixSquare            }
];
